import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from '@nuxt/ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7bf0fa6b = () => interopDefault(import('..\\pages\\about.vue' /* webpackChunkName: "pages/about" */))
const _bab229b4 = () => interopDefault(import('..\\pages\\goal1\\index.vue' /* webpackChunkName: "pages/goal1/index" */))
const _ab4edef6 = () => interopDefault(import('..\\pages\\goal2\\index.vue' /* webpackChunkName: "pages/goal2/index" */))
const _9beb9438 = () => interopDefault(import('..\\pages\\goal3\\index.vue' /* webpackChunkName: "pages/goal3/index" */))
const _8c88497a = () => interopDefault(import('..\\pages\\goal4\\index.vue' /* webpackChunkName: "pages/goal4/index" */))
const _7d24febc = () => interopDefault(import('..\\pages\\goal5\\index.vue' /* webpackChunkName: "pages/goal5/index" */))
const _a359c5d4 = () => interopDefault(import('..\\pages\\guardrail1\\index.vue' /* webpackChunkName: "pages/guardrail1/index" */))
const _93f67b16 = () => interopDefault(import('..\\pages\\guardrail2\\index.vue' /* webpackChunkName: "pages/guardrail2/index" */))
const _84933058 = () => interopDefault(import('..\\pages\\guardrail3\\index.vue' /* webpackChunkName: "pages/guardrail3/index" */))
const _752fe59a = () => interopDefault(import('..\\pages\\guardrail4\\index.vue' /* webpackChunkName: "pages/guardrail4/index" */))
const _a016f752 = () => interopDefault(import('..\\pages\\goal1\\fall.vue' /* webpackChunkName: "pages/goal1/fall" */))
const _4d0d962e = () => interopDefault(import('..\\pages\\goal1\\spring.vue' /* webpackChunkName: "pages/goal1/spring" */))
const _345f2da1 = () => interopDefault(import('..\\pages\\goal1\\winter.vue' /* webpackChunkName: "pages/goal1/winter" */))
const _44d93718 = () => interopDefault(import('..\\pages\\goal2\\fall.vue' /* webpackChunkName: "pages/goal2/fall" */))
const _0c5ac1c0 = () => interopDefault(import('..\\pages\\goal2\\hows.vue' /* webpackChunkName: "pages/goal2/hows" */))
const _7007892c = () => interopDefault(import('..\\pages\\goal2\\spring.vue' /* webpackChunkName: "pages/goal2/spring" */))
const _22e23422 = () => interopDefault(import('..\\pages\\goal2\\winter.vue' /* webpackChunkName: "pages/goal2/winter" */))
const _4c842c4e = () => interopDefault(import('..\\pages\\goal3\\fall.vue' /* webpackChunkName: "pages/goal3/fall" */))
const _bd8116fe = () => interopDefault(import('..\\pages\\goal3\\hows.vue' /* webpackChunkName: "pages/goal3/hows" */))
const _93017c2a = () => interopDefault(import('..\\pages\\goal3\\spring.vue' /* webpackChunkName: "pages/goal3/spring" */))
const _11653aa3 = () => interopDefault(import('..\\pages\\goal3\\winter.vue' /* webpackChunkName: "pages/goal3/winter" */))
const _6ea29c9a = () => interopDefault(import('..\\pages\\goal4\\fall.vue' /* webpackChunkName: "pages/goal4/fall" */))
const _36242742 = () => interopDefault(import('..\\pages\\goal4\\hows.vue' /* webpackChunkName: "pages/goal4/hows" */))
const _b5fb6f28 = () => interopDefault(import('..\\pages\\goal4\\spring.vue' /* webpackChunkName: "pages/goal4/spring" */))
const _002f7db8 = () => interopDefault(import('..\\pages\\goal4\\winter.vue' /* webpackChunkName: "pages/goal4/winter" */))
const _30614d26 = () => interopDefault(import('..\\pages\\goal5\\endnotes.vue' /* webpackChunkName: "pages/goal5/endnotes" */))
const _06bc2746 = () => interopDefault(import('..\\pages\\goal5\\final.vue' /* webpackChunkName: "pages/goal5/final" */))
const _69ee4bfa = () => interopDefault(import('..\\pages\\goal5\\hows.vue' /* webpackChunkName: "pages/goal5/hows" */))
const _13aec966 = () => interopDefault(import('..\\pages\\goal5\\quarter2.vue' /* webpackChunkName: "pages/goal5/quarter2" */))
const _2d83df0f = () => interopDefault(import('..\\pages\\guardrail1\\hows.vue' /* webpackChunkName: "pages/guardrail1/hows" */))
const _62a26422 = () => interopDefault(import('..\\pages\\guardrail1\\indicator2.vue' /* webpackChunkName: "pages/guardrail1/indicator2" */))
const _62863520 = () => interopDefault(import('..\\pages\\guardrail1\\indicator3.vue' /* webpackChunkName: "pages/guardrail1/indicator3" */))
const _7b2edc60 = () => interopDefault(import('..\\pages\\guardrail2\\hows.vue' /* webpackChunkName: "pages/guardrail2/hows" */))
const _574d4491 = () => interopDefault(import('..\\pages\\guardrail3\\hows.vue' /* webpackChunkName: "pages/guardrail3/hows" */))
const _700289f1 = () => interopDefault(import('..\\pages\\guardrail3\\indicator2.vue' /* webpackChunkName: "pages/guardrail3/indicator2" */))
const _e53ef852 = () => interopDefault(import('..\\pages\\guardrail4\\suspensions.vue' /* webpackChunkName: "pages/guardrail4/suspensions" */))
const _94f40856 = () => interopDefault(import('..\\pages\\implementationFrameworks\\AcademicFrameworks.vue' /* webpackChunkName: "pages/implementationFrameworks/AcademicFrameworks" */))
const _1fa1588a = () => interopDefault(import('..\\pages\\implementationFrameworks\\AcademicScreeners.vue' /* webpackChunkName: "pages/implementationFrameworks/AcademicScreeners" */))
const _3d0a9a0e = () => interopDefault(import('..\\pages\\implementationFrameworks\\CommonPlanningTime.vue' /* webpackChunkName: "pages/implementationFrameworks/CommonPlanningTime" */))
const _12e5c3a0 = () => interopDefault(import('..\\pages\\implementationFrameworks\\MTSS.vue' /* webpackChunkName: "pages/implementationFrameworks/MTSS" */))
const _c8ae55a0 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'hash',
  base: '/extensions/goals-and-guardrails/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _7bf0fa6b,
    name: "about"
  }, {
    path: "/goal1",
    component: _bab229b4,
    name: "goal1"
  }, {
    path: "/goal2",
    component: _ab4edef6,
    name: "goal2"
  }, {
    path: "/goal3",
    component: _9beb9438,
    name: "goal3"
  }, {
    path: "/goal4",
    component: _8c88497a,
    name: "goal4"
  }, {
    path: "/goal5",
    component: _7d24febc,
    name: "goal5"
  }, {
    path: "/guardrail1",
    component: _a359c5d4,
    name: "guardrail1"
  }, {
    path: "/guardrail2",
    component: _93f67b16,
    name: "guardrail2"
  }, {
    path: "/guardrail3",
    component: _84933058,
    name: "guardrail3"
  }, {
    path: "/guardrail4",
    component: _752fe59a,
    name: "guardrail4"
  }, {
    path: "/goal1/fall",
    component: _a016f752,
    name: "goal1/fall"
  }, {
    path: "/goal1/spring",
    component: _4d0d962e,
    name: "goal1/spring"
  }, {
    path: "/goal1/winter",
    component: _345f2da1,
    name: "goal1/winter"
  }, {
    path: "/goal2/fall",
    component: _44d93718,
    name: "goal2/fall"
  }, {
    path: "/goal2/hows",
    component: _0c5ac1c0,
    name: "goal2/hows"
  }, {
    path: "/goal2/spring",
    component: _7007892c,
    name: "goal2/spring"
  }, {
    path: "/goal2/winter",
    component: _22e23422,
    name: "goal2/winter"
  }, {
    path: "/goal3/fall",
    component: _4c842c4e,
    name: "goal3/fall"
  }, {
    path: "/goal3/hows",
    component: _bd8116fe,
    name: "goal3/hows"
  }, {
    path: "/goal3/spring",
    component: _93017c2a,
    name: "goal3/spring"
  }, {
    path: "/goal3/winter",
    component: _11653aa3,
    name: "goal3/winter"
  }, {
    path: "/goal4/fall",
    component: _6ea29c9a,
    name: "goal4/fall"
  }, {
    path: "/goal4/hows",
    component: _36242742,
    name: "goal4/hows"
  }, {
    path: "/goal4/spring",
    component: _b5fb6f28,
    name: "goal4/spring"
  }, {
    path: "/goal4/winter",
    component: _002f7db8,
    name: "goal4/winter"
  }, {
    path: "/goal5/endnotes",
    component: _30614d26,
    name: "goal5/endnotes"
  }, {
    path: "/goal5/final",
    component: _06bc2746,
    name: "goal5/final"
  }, {
    path: "/goal5/hows",
    component: _69ee4bfa,
    name: "goal5/hows"
  }, {
    path: "/goal5/quarter2",
    component: _13aec966,
    name: "goal5/quarter2"
  }, {
    path: "/guardrail1/hows",
    component: _2d83df0f,
    name: "guardrail1/hows"
  }, {
    path: "/guardrail1/indicator2",
    component: _62a26422,
    name: "guardrail1/indicator2"
  }, {
    path: "/guardrail1/indicator3",
    component: _62863520,
    name: "guardrail1/indicator3"
  }, {
    path: "/guardrail2/hows",
    component: _7b2edc60,
    name: "guardrail2/hows"
  }, {
    path: "/guardrail3/hows",
    component: _574d4491,
    name: "guardrail3/hows"
  }, {
    path: "/guardrail3/indicator2",
    component: _700289f1,
    name: "guardrail3/indicator2"
  }, {
    path: "/guardrail4/suspensions",
    component: _e53ef852,
    name: "guardrail4/suspensions"
  }, {
    path: "/implementationFrameworks/AcademicFrameworks",
    component: _94f40856,
    name: "implementationFrameworks/AcademicFrameworks"
  }, {
    path: "/implementationFrameworks/AcademicScreeners",
    component: _1fa1588a,
    name: "implementationFrameworks/AcademicScreeners"
  }, {
    path: "/implementationFrameworks/CommonPlanningTime",
    component: _3d0a9a0e,
    name: "implementationFrameworks/CommonPlanningTime"
  }, {
    path: "/implementationFrameworks/MTSS",
    component: _12e5c3a0,
    name: "implementationFrameworks/MTSS"
  }, {
    path: "/",
    component: _c8ae55a0,
    name: "index"
  }],

  fallback: false
}

function decodeObj(obj) {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = decode(obj[key])
    }
  }
}

export function createRouter () {
  const router = new Router(routerOptions)

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    const r = resolve(to, current, append)
    if (r && r.resolved && r.resolved.query) {
      decodeObj(r.resolved.query)
    }
    return r
  }

  return router
}
